module.exports = __webpack_public_path__ + "media/images/samples/infographics/info-2@2x-e0e5237444ff444a45e36b52d662c3cf.jpg";